import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/app-dir/link.js");
